// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18hv5","select":"styles_select__vlpu3"};